import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
// import { AuthService } from '../../services/auth.service';
import * as fromApp from '../../store/app.reducer';
import * as AuthSelectors from '../../store/selectors/auth.selector';

@Injectable({ providedIn: 'root' })
export class AuthPageGuard  {
  constructor(private router: Router, private store: Store<fromApp.AppState>) {}

  canActivate(): Observable<true | UrlTree> {
    return this.store.select(AuthSelectors.selectActiveUser).pipe(
      take(1),
      // map((user) => user),
      map((activeUser) => {
        if (!!activeUser) {
          return this.router.createUrlTree(['/']);
        } else {
          return true;
        }
      })
    );
  }
}
